import React, { useEffect, useState } from "react";

//Converting to Date nd Month
export const convertToDateMonthFormat = (val: any) => {
  if (val) {
    const date = new Date(val); // Convert to Date object
    const localDate = date.toLocaleString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return localDate; // Return the formatted local date
  }
  return ""; // Return an empty string or handle as needed when val is falsy
};

//Converting local to UTC time Zone
export const convertToUTC = (date: any): string | null => {
  if (date) {
    const localDate = new Date(date); // Create a Date object from the local date
    // Create a UTC date using localDate's full components

    const utcDate = new Date(
      Date.UTC(
        localDate.getFullYear(), // Year
        localDate.getMonth(), // Month (0-11)
        localDate.getDate(), // Day of the month (1-31)
        localDate.getHours(), // Hours (0-23)
        localDate.getMinutes(), // Minutes (0-59)
        localDate.getSeconds() // Seconds (0-59)
      )
    );

    return utcDate.toISOString(); // Convert to UTC string
  }
  return null; // Return null if date is falsy
};

export const isClientAdmin = (roles: any[], companyProfileID: number) => {
  if (roles.length > 0) {
    let roleType = roles.find(
      (ele) => ele.companyProfileID === companyProfileID
    );
    console.log("isClientAdmin", roleType);
    return roleType?.roleName && roleType.roleName === "ClientAdmin";
  }
  return false;
};
